import { mergeDeepRight } from 'ramda'

import { theme as generatedTheme } from '../theme-generated'
import { SpacingNumeric, SpacingString } from './utils/spacing'

const theme = mergeDeepRight(generatedTheme, {
  UI: {
    BorderRadius: {
      Small: 4,
      Large: 8,
    },
    SpacingPx: SpacingString,
    Spacing: SpacingNumeric,
  },

  Colors: {},
})

export { theme }
